import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Search } from "lucide-react";
import type { TicketStatus, TicketCategory } from "./types";

const STATUS_OPTIONS: { value: TicketStatus | "ALL"; label: string }[] = [
  { value: "ALL", label: "All Statuses" },
  { value: "OPEN", label: "Open" },
  { value: "RESOLVED", label: "Resolved" },
  { value: "CLOSED", label: "Closed" },
];

const CATEGORY_OPTIONS: { value: TicketCategory | "ALL"; label: string }[] = [
  { value: "ALL", label: "All Categories" },
  { value: "GENERAL_QUESTION", label: "General" },
  { value: "TECHNICAL_QUESTION", label: "Technical" },
  { value: "REFUND_REQUEST", label: "Refund" },
];

interface TicketFiltersProps {
  search: string;
  onSearchChange: (v: string) => void;
  statusFilter: TicketStatus | "ALL";
  onStatusChange: (v: TicketStatus | "ALL") => void;
  categoryFilter: TicketCategory | "ALL";
  onCategoryChange: (v: TicketCategory | "ALL") => void;
}

export function TicketFilters({
  search,
  onSearchChange,
  statusFilter,
  onStatusChange,
  categoryFilter,
  onCategoryChange,
}: TicketFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-3">
      <div className="relative flex-1 sm:max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
        <Input
          placeholder="Search by subject or sender..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9"
        />
      </div>

      <Select
        value={statusFilter}
        onValueChange={(v: TicketStatus | "ALL" | null) => {
          if (v !== null) onStatusChange(v);
        }}
      >
        <SelectTrigger className="w-full sm:w-44" aria-label="Status filter">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {STATUS_OPTIONS.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={categoryFilter}
        onValueChange={(v: TicketCategory | "ALL" | null) => {
          if (v !== null) onCategoryChange(v);
        }}
      >
        <SelectTrigger className="w-full sm:w-48" aria-label="Category filter">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {CATEGORY_OPTIONS.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
